import React from 'react'
import { useUpdateEntriesMutation } from '../../api/ctliveApi'
import useAppSelector from '../../hooks/useAppSelector'
import {
  getDownloadPercentageSelector,
  getEntriesUrlFetchInProgressSelector,
  getS3EntriesUpdatedForOfflineUse,
  getS3FetchInProgress
} from '../../features/data/dataSlice'
import { getOnlineSelector } from '../../features/network/networkSlice'
import CircularProgressWithLabel from './CircularProgressWithLabel'
import { CircularProgress } from '@mui/material'

const CheckinLoader = () => {
  const online = useAppSelector(getOnlineSelector)
  const entriesUrlFetchInProgress = useAppSelector(getEntriesUrlFetchInProgressSelector)
  const s3FetchInProgress = useAppSelector(getS3FetchInProgress)
  const [, { isLoading: isLoadingPut }] = useUpdateEntriesMutation()
  const onlineLoading = online && (entriesUrlFetchInProgress || s3FetchInProgress || isLoadingPut)

  const entriesUpdatedForOfflineUse = useAppSelector(getS3EntriesUpdatedForOfflineUse)
  const offlineLoading = !online && !entriesUpdatedForOfflineUse

  const progress = useAppSelector(getDownloadPercentageSelector) || 0

  if (onlineLoading) {
    return (
      <CircularProgressWithLabel
        label={'Downloading Athletes'}
        progress={progress}
      />
    )
  }
  else if (offlineLoading) {
    return (
      <CircularProgress size={20} thickness={5} />
    )
  }
  return null
}

export default CheckinLoader
